<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Jhipru and Chimnayano </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Jhipru and <span>Chimnayano </span></h2>
        </div>
        <div class="row">
            <div class="col-md-8 up-event-text mt-5">
                <!-- <h4 class="fw-bold">G H Raisoni Memorial District Level singing Competition   </h4> -->
                <h6 class="fw-bold">
                    <strong>10<sup>th</sup> Nov 2024 </strong>
                </h6>
                <p>'झिपरू' हे बालनाट्य आणि 'या चिमण्यांनो' हा बालगीतांचा कार्यक्रम आयोजित करण्यात आला होता </p>
                <p>
                    <strong>Event Name :-</strong> Jhipru and Chimnayano <br />
                </p>
                <p><strong>Date :-</strong> 10.11.2024 <br /></p>

                <p><strong> Time :-</strong> 10:00 am to 3:00 pm <br />
                <p><strong>Venue :</strong> Auditorium Mangalwari campus </p>
                <br />
                <p><strong class="mt-5">रविवारी, १० नोव्हेंबर २०२४ रोजी सकाळी ११ वाजता</strong> रिआन टावर ऑडीटोरीअममध्ये
                    नागपूर येथील बाळगोपाळांसाठी एक खास बालनाट्य आणि बालगीतांचा कार्यक्रम आयोजित करण्यात आला होता. याचे
                    दिग्दर्शन पुण्यातील प्रसिद्ध नाट्य आणि चित्रपट दिग्दर्शक श्री. शेखर नाईक यांनी केले होते.</p>
                <br>
                <p><strong>कथा :-</strong> "झिपरु" हे बालनाट्य डॉक्टर संगीता बर्वे यांच्या कादंबरीवर आधारित आहे. या
                    नाटकाची कथा एका अस्वलाच्या व्यथा आणि त्याच्या मुक्ततेच्या संघर्षावर आधारित आहे. जंगलातून सर्कस मध्ये
                    पळवून आणलेल्या झिपरु या अस्वलाच्या आई-वडिलांचा वध करून, त्याला सर्कस मालकाने आपल्या ताब्यात घेतले
                    आहे. त्याची सुटका गावातील लहान मुलांनी, ज्युली ह्या सर्कशीतील मुलीच्या मदतीने केली आहे. नाटक
                    प्राण्यांच्या भावना आणि त्यांचे हक्क यावर प्रकाश टाकते.</p>
            </div>
            <div class="col-lg-4 text-center">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jhipriplay.avif"
                    alt="play-competition" title="play-competition" class="img-fluid" />
            </div>
        </div>

        <p><strong>नाट्य रूपांतर, नेपथ्य आणि दिग्दर्शन :-</strong> शेखर नाईक</p>
        <p><strong>संगीत :-</strong> उदय रामदास</p>
        <p><strong>गायक :-</strong> प्रांजली बर्वे, हृदया दातार, शर्व दाते, सानिका आपटे</p>
        <p><strong>वेशभूषा :-</strong> गायत्री चक्रदेव</p>
        <p><strong>कलाकार :-</strong> शर्व दाते, श्रिया जोशी, श्रुति जोशी, सन्मित्र जोशी, वेद पुरोहित, कियान बोरकर,
            अथर्व बागडी, ईश्वरी जाधव, हृदया दातार
            याचा कालावधी: ६५ मिनिटे होता.</p>
        <p><strong>या चिमण्यांनो बालगीतांचा कार्यक्रम</strong></p>
        <p>हा एक आनंददायक बालगीतांचा कार्यक्रम झाला. यातील बाल कलाकारांनी सर्वांची मनं ओलांडणारी बालगीते गाऊन मुलांसाठी
            आणि पालकांसाठी खास आनंदाचा अनुभव दिला होता.
            याचा कालावधी: ८० मिनिटे होता.</p>
        <p><strong>कार्यक्रमाचे महत्त्व :-</strong></p>
        <p>
            या कार्यक्रमाच्या माध्यमातून लहान मुलांना प्राणी जगत, पर्यावरण आणि त्याच्या संवेदनशीलतेबद्दल महत्त्वाची
            शिकवण मिळेल.
            "झिपरु" नाटकाने प्राण्यांच्या भावना आणि त्यांच्या स्थितीवर समाजाचा दृष्टिकोन बदलण्याचा प्रयत्न केला आहे.
            कार्यक्रमातील शिक्षण आणि मनोरंजनाच्या मिश्रणामुळे बालवर्गासाठी हा एक उत्कृष्ट अनुभव ठरला.</p>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Play</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="https://drive.google.com/drive/folders/1J0xRUpXkFiqqCxeBFmR4QF5P3TsCTzCg"
                                target="_blank" class="cmn-button">
                                <span> View More</span>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-1.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-1.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-1.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-2.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-2.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-2.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-3.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-3.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-3.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>

                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-4.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-4.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-4.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-5.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-5.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-5.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-6.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-6.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-6.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-7.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-7.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-7.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-8.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-8.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-8.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-9.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-9.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/play/play-9.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold"> Singing</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="https://drive.google.com/drive/folders/1J0xRUpXkFiqqCxeBFmR4QF5P3TsCTzCg"
                                target="_blank" class="cmn-button">
                                <span> View More</span>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-3.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-3.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-3.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-4.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-4.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-4.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-5.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-5.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-5.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-6.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-6.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-6.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-7.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-7.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-7.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-8.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-8.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-8.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-9.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-9.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-9.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-10.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-10.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/singing/singing-10.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                            alt="GHRSCF" />
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
